import React from "react";

const SvgAlignLeftIcon = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width || "1em"}
      height={width || "1em"}
      viewBox="0 0 100 80"
      style={style}
      fill="currentColor"
    >
      <defs />
      <defs>
        <clipPath id="clip-Left">
          <path d="M0 0h100v80H0z" />
        </clipPath>
      </defs>
      <g id="Left" clip-path="url(#clip-Left)">
        <g id="left-align">
          <g id="Group_19832" data-name="Group 19832">
            <g id="Group_19831" data-name="Group 19831">
              <path
                id="Path_38513"
                d="M97.164 31.5H3.008a3.008 3.008 0 100 6.016h94.156a3.008 3.008 0 100-6.016z"
                data-name="Path 38513"
                transform="translate(0 -31.5)"
              />
            </g>
          </g>
          <g
            id="Group_19834"
            data-name="Group 19834"
            transform="translate(0 24.563)"
          >
            <g id="Group_19833" data-name="Group 19833">
              <path
                id="Path_38514"
                d="M69.188 114.5H3.008a3.008 3.008 0 100 6.016h66.18a3.008 3.008 0 100-6.016z"
                data-name="Path 38514"
                transform="translate(0 -114.5)"
              />
            </g>
          </g>
          <g
            id="Group_19836"
            data-name="Group 19836"
            transform="translate(0 49.421)"
          >
            <g id="Group_19835" data-name="Group 19835">
              <path
                id="Path_38515"
                d="M97.164 198.5H3.008a3.008 3.008 0 100 6.016h94.156a3.008 3.008 0 100-6.016z"
                data-name="Path 38515"
                transform="translate(0 -198.5)"
              />
            </g>
          </g>
          <g
            id="Group_19838"
            data-name="Group 19838"
            transform="translate(0 73.984)"
          >
            <g id="Group_19837" data-name="Group 19837">
              <path
                id="Path_38516"
                d="M45.423 281.5H3.008a3.008 3.008 0 100 6.016h42.415a3.008 3.008 0 100-6.016z"
                data-name="Path 38516"
                transform="translate(0 -281.5)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SvgAlignLeftIcon;
